import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";

const FooterCopyright = ({ footerLogo, spaceBottomClass, colorClass }) => {
  return (
    <div className={clsx("copyright", spaceBottomClass, colorClass)}>
      <div className="footer-logo px-2">
        <Link to={process.env.PUBLIC_URL + "/"}>
          <img alt="" src={process.env.PUBLIC_URL + footerLogo} width={128} />
        </Link>
      </div>

      <div className="d-flex justify-content-center gap-3  p-2">
        <div>
          <a href="https://www.facebook.com/tcxela001/?locale=es_LA" target="_blank" rel="noopener noreferrer">
            <span className="text-theme-color-dark">
              <FaFacebook size={24} />
            </span>
          </a>
        </div>
        <div>
          <a href="https://www.instagram.com/telefoniacastro/" target="_blank" rel="noopener noreferrer">
            <span className="text-theme-color-dark">
              <FaInstagram size={24} />
            </span>
          </a>
        </div>
      </div>
      <p className="text-dark mb-0">
        &copy; {new Date().getFullYear()} Telefonía Castro
      </p>
      <p className="text-dark mb-0 tc-powered-by-line">
        Powered by{" "}
        <a
          className="tc-powered-by-link"
          href="https://dssolutionsgt.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          DS-Solutions-GT
        </a>
      </p>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
};

export default FooterCopyright;
